@if (showAppHeader? showAppHeader:false) {
  <header #appHeader class="header" [ngClass]="showLogin ? 'settings-header':''"
    >
    <div class="header-row">
      <div class="header-notification" [ngClass]="showLogin ? 'settings-head':''">
        @if (!showLogin) {
          <ul>
            <li class="hamber-icon" (click)="expandmenu()"><a class="menu-icon"><i class="icon-path"
            id="menuIcon"></i></a>
            @if (_cs.tempCanshowpasscodepopup) {
              <span class='fil-circle head-notification'
              ></span>
            }</li>
            @if (!showLogo) {
              <li class="mt-1"><a class="logo-section">
                <img class="header-logo" src="assets/images/Eatec_white_Logo.svg" alt="header-log">
              </a>
            </li>
          }
          <li class="header-search">
            <auto-complete class="auto-search"></auto-complete>
          </li>
          <li class="dateTime-info" [matMenuTriggerFor]="timezone">
            <span class="date-info">{{currentDateInfo}}</span><span class="time-info">{{currentTimeInfo}}</span><br/>
            <p class="timeZone-info m-0">{{timezoneDescription}}</p>
            <mat-menu #timezone="matMenu">
              <ng-container>
                <p class="timezone-desc" id="timezone-desc">{{timezoneDescription}}</p>
              </ng-container>
            </mat-menu>
          </li>
          <li class="mt-2 search-icon"><a class="padding-left-15"><i class="icon-Forma--1"></i></a></li>
          @if (messageConfig && messageConfig.hasOwnProperty('Visible') ? messageConfig.Visible :false ) {
            <li [ngClass]="[!_cs.isonlineStatus ? 'disabled':'', messageConfig && messageConfig.hasOwnProperty('Enabled') ? !messageConfig.Enabled ? 'disabled' : '' :'' ]"
              class="mt-2 message-icon">
              <a class="padding-left-15" (click)='messageClick()'><i
                class="icon-{{ messageConfig && messageConfig.hasOwnProperty('Icon') && messageConfig.Icon ? messageConfig.Icon : 'message-2-icon'  }}"
              id="{{ messageConfig && messageConfig.hasOwnProperty('Icon') && messageConfig.Icon ? messageConfig.Icon : 'message-2-icon'}}"></i>@if (showNewMessage) {
              <span
              class='fil-circle'></span>
            }</a>
          </li>
        }
        <li class="mt-2 alert-icon"><a class="padding-left-15"><i class="icon-Forma-1"></i></a></li>
        <li class="circle-btn"><a class="padding-left-15"><span class="circle-button"
          [matMenuTriggerFor]="siteMenu">{{siteAbbreviation}}
          <span class='fil-circle onlinePosition'
          [ngClass]="_cs.isonlineStatus? 'online':'offline'"></span>
        </span></a>
        <mat-menu #siteMenu="matMenu">
          <ng-container>
            <p class="siteMenu_text" id="siteMenu_text">{{SiteFullName}}</p>
          </ng-container>
        </mat-menu>
      </li>
      <li>
        <mat-form-field class="login-user header-dropdown padding-left-15">
          <mat-select [(value)]="selected">
            <mat-option value="option1">Option 1</mat-option>
            <mat-option value="option2">Option 2</mat-option>
            <mat-option value="option3">Option 3</mat-option>
          </mat-select>
        </mat-form-field>
      </li>
    </ul>
  }
  @if (showLogin) {
    <div class="login-sec">
      <div class="back-div">
        <i class="icon-back backIcon" (click)="goTologin()"></i>
        <label class="l-text">{{globalSettings}}</label>
      </div>
    </div>
  }
</div>
</div>
</header>
}